<template>
	<div>
		<AppTooltip position="bottom" :text="app.service_name">
			<div class="display-flex flex-row flex-align-center card-container">
				<v-img :src="app.icon" class="icon-container" />
			</div>
		</AppTooltip>
	</div>
</template>
<script>
export default {
	name: 'CurrentSelectedAppCard',
	props: { app: { type: Object } },
};
</script>
<style lang="scss" scoped>
.card-container {
	padding: 6px;
	min-width: 30px;
	max-width: 30px;
	min-height: 30px;
	max-height: 30px;
	border-radius: 5px;
	border: 1px solid #d6ddea;
}
</style>
